export const formatWeatherApiData = (data, weatherType) => {
    let typedData;
    // @ts-ignore
    if (weatherType === "hourly") {
        typedData = data;
        const result = {
            city: {
                name: typedData.city.name,
                country: typedData.city.country,
            },
            weather: typedData.list.slice(0, 6).map((item) => ({
                // @ts-ignore
                date: new Date((item.dt - typedData.city.timezone) * 1000),
                icon: item.weather[0].icon,
                description: item.weather[0].description,
                temp: item.main.temp,
                temp_max: item.main.temp_max,
                temp_min: item.main.temp_min,
            })),
        };
        // @ts-ignore
        return result;
    }
    if (weatherType === "daily") {
        typedData = data;
        const daysAmount = 5;
        // Obtain daily weather (API doesn't provide for free)
        const resultWeather = Array.from({ length: daysAmount }, (_, i) => i + 1).map((index) => {
            typedData = data;
            const lowestTemp = Math.min(...typedData.list
                .slice(8 * (index - 1), 8 * index)
                .map((item) => item.main.temp_min));
            const highestTemp = Math.max(...typedData.list
                .slice(8 * (index - 1), 8 * index)
                .map((item) => item.main.temp_max));
            const bestConditionIcon = typedData.list
                .slice(8 * (index - 1), 8 * index)
                .map((item) => item.weather[0].icon)
                .sort()[0];
            const bestConditionDescription = typedData.list
                .slice(8 * (index - 1), 8 * index)
                .filter((item) => item.weather[0].icon === bestConditionIcon)[0]
                .weather[0].description;
            return {
                // @ts-ignore
                date: new Date((typedData.list[8 * (index - 1)].dt - typedData.city.timezone) * 1000),
                icon: bestConditionIcon,
                description: bestConditionDescription,
                temp: 0,
                temp_max: lowestTemp,
                temp_min: highestTemp,
            };
        });
        const result = {
            city: {
                name: typedData.city.name,
                country: typedData.city.country,
            },
            weather: resultWeather,
        };
        // @ts-ignore
        return result;
    }
    typedData = data;
    const result = {
        city: {
            country: typedData.sys.country,
            name: typedData.name,
        },
        weather: {
            date: new Date(typedData.dt * 1000),
            icon: typedData.weather[0].icon,
            description: typedData.weather[0].description,
            temp: typedData.main.temp,
            temp_max: typedData.main.temp_max,
            temp_min: typedData.main.temp_min,
        },
    };
    // @ts-ignore
    return result;
};
export const formatWeatherTemp = ({ temp, unit, }) => {
    if (unit === "fahrenheit") {
        return `${Math.round(temp * (9 / 5) + 32)}°F`;
    }
    return `${Math.round(temp)}°C`;
};
